// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1a7Tr","productName":"Table_productName__2LpN8"};